import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ClipboardCheckIcon, BookOpenIcon, LayoutGridIcon, TrendingUpIcon } from 'lucide-react';
const features = [{
  icon: <FileTextIcon className="w-6 h-6 text-golden" data-id="element-43" />,
  title: 'Módulo 1 – Informes terapéuticos profesionales',
  description: 'Plantillas listas para generar informes claros y profesionales en minutos.',
  items: ['Informe inicial del paciente', 'Informe de evolución terapéutica', 'Informe para instituciones o escuelas', 'Informe para familia', 'Informe de alta terapéutica']
}, {
  icon: <ClipboardCheckIcon className="w-6 h-6 text-golden" data-id="element-44" />,
  title: 'Módulo 2 – Evaluaciones terapéuticas',
  description: 'Fichas estructuradas para evaluar diferentes áreas del desarrollo del paciente.',
  items: ['Motricidad fina', 'Coordinación motora', 'Habilidades cognitivas', 'Autonomía personal', 'Actividades de la vida diaria']
}, {
  icon: <BookOpenIcon className="w-6 h-6 text-golden" data-id="element-45" />,
  title: 'Módulo 3 – Registro de sesiones terapéuticas',
  description: 'Plantillas simples para registrar cada sesión de manera organizada.',
  items: ['Objetivos terapéuticos', 'Actividades realizadas', 'Evolución del paciente', 'Observaciones profesionales']
}, {
  icon: <LayoutGridIcon className="w-6 h-6 text-golden" data-id="element-46" />,
  title: 'Módulo 4 – Banco de actividades terapéuticas',
  description: 'Actividades listas para aplicar directamente en sesión.',
  items: ['Motricidad fina', 'Coordinación motora', 'Estimulación cognitiva', 'Rehabilitación funcional']
}, {
  icon: <TrendingUpIcon className="w-6 h-6 text-golden" data-id="element-47" />,
  title: 'Módulo 5 – Seguimiento del progreso',
  description: 'Herramientas para registrar la evolución terapéutica de cada paciente.',
  items: ['Seguimiento mensual', 'Registro de objetivos alcanzados', 'Evolución por áreas terapéuticas']
}];
export function FeaturesSection() {
  return <section className="py-8 px-4 bg-cream" data-id="element-48">
      <div className="max-w-5xl mx-auto" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-50">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-olive-dark mb-4" data-id="element-51">
            ¿Qué incluye el <span className="text-golden" data-id="element-52">Sistema PRO</span>?
          </h2>
          <p className="text-base md:text-lg text-olive/80 max-w-3xl mx-auto leading-relaxed" data-id="element-53">
            Un sistema completo de recursos profesionales listos para usar.
            Incluye 5 módulos con plantillas, evaluaciones y recursos
            terapéuticos que podés utilizar directamente en tu práctica.
          </p>
        </motion.div>

        <div className="space-y-3" data-id="element-54">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-warm-beige/50 backdrop-blur-sm px-5 py-4 rounded-xl shadow-sm border border-olive/5 flex items-start gap-4" data-id="element-55">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm shrink-0 mt-0.5" data-id="element-56">
                {feature.icon}
              </div>
              <div className="flex-1 min-w-0" data-id="element-57">
                <h3 className="text-base font-bold text-olive-dark font-serif" data-id="element-58">
                  {feature.title}
                </h3>
                <p className="text-olive/80 text-sm mt-1" data-id="element-59">
                  {feature.description}
                </p>
                <div className="flex flex-wrap gap-x-3 gap-y-1 mt-2" data-id="element-60">
                  {feature.items.map((item, i) => <span key={i} className="text-xs text-olive/60 before:content-['•'] before:mr-1 before:text-golden" data-id="element-61">
                      {item}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}